<template>
    <div class="main" v-if="!loading">
        
        <el-form @submit.native.prevent="onSubmit" label-position="top">

            <div class="u-mb-20" style="display: flex; align-items: center;">
                <h3 class="u-mb-5">Lançamento de notas em toda a Rede</h3>
                <i style="margin-top: 10px; margin-left: 5px;">- Períodos disponíveis para lançamento de notas para todas as instituições ativas.</i>
            </div>

            <el-checkbox-group v-model="dados" class="checkbox-filtos">
                <template v-for="(item, i) in periodos" >
                    <el-checkbox :label="i">{{ item }}</el-checkbox>
                </template>
            </el-checkbox-group>
            
            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item class="u-text-right">
                        <el-button type="primary" native-type="submit">SALVAR PARA TODA A REDE</el-button>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
    </div>
</template>
<script>

export default {
    data () {
        return {
            loading: false,
            periodos:[],
            dados: []
        }
    },
    mounted() {
        this.initFormParametros();
    },
    methods:{
        async initFormParametros(){

            this.loading = true;

            let response = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/initFormParametrosRede`, this.$store.getters.getHeaderAuth);
            
            this.periodos = JSON.parse(JSON.stringify(response.data.options));

            this.dados = JSON.parse(JSON.stringify(response.data.dados));
                    
            this.loading = false;
        },        
        async onSubmit (){

            window.eventBus.$emit('loading', true);

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeParamAcoesNotasRede`, this.dados, this.$store.getters.getHeaderAuth);

            if(typeof response.data.error !== 'undefined'){

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});

            }else{

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                this.initFormParametros();
            }

        },
    }    
}
</script>